// Discourse's rich editor turns the 4th leading space into a code block
// (`textblockTypeInputRule(/^ {4}$/)`). Detect that conversion so we can
// put the spaces back as plain text.

export function restoredParagraphAfterFourSpaces(paragraphText, cursorOffset) {
  if (paragraphText.slice(0, cursorOffset) !== "   ") {
    return null;
  }

  return `    ${paragraphText.slice(cursorOffset)}`;
}
